/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"

export const listContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const listItemContainer = css`
  width: 100%;
  padding: 24px;
  cursor: pointer;
  :hover {
    background-color: #f9f9f9;
    .itemActionContainer {
      display: block;
    }
  }
  flex-wrap: nowrap;
`

export const listActionContainer = css`
  width: 100%;
  padding: 24px;
  cursor: pointer;
`

export const listItemDivider = css`
  margin: 0;
  width: calc(100% - 48px);
`

export const listLabelContainer = css`
  font-size: 16px;
`

export const checkableButtonContainer = (checked: boolean) => css`
  flex-grow: 1;
  flex-basis: 0;
  button {
    width: 100%;
    border-radius: 0;
    font-weight: normal;
    border-color: #ffffff !important;
    background: #f5f5f5 !important;
    &:not([disabled]) {
      &:hover {
          ${!checked &&
            css`
              color: #00a5cf !important;
            `}
          box-shadow: -1px 0px 0px 0px #00a5cf;
          border-color: #00a5cf !important;
        }
        ${checked &&
          css`
            background-color: #00a5cf !important;
            color: #ffffff !important;
          `}
      }
      &:focus {
        ${!checked &&
          css`
            color: unset !important;
          `}
      }
    }
  }
  &:first-of-type {
    button {
      box-shadow: unset !important;
      border-radius: 8px 0px 0px 8px;
    }
  }
  &:last-child {
    button {
      border-radius: 0px 8px 8px 0px;
    }
  }
  &:not(:first-of-type) {
    button {
      border-left: 0 !important;
    }
  }
`
